import { useState, type FormEvent } from 'react';
import { Button, Card, Input } from '../atoms';
import { FormField, Wordmark } from '../molecules';

interface LoginFormProps {
  onSubmit: (identifier: string, password: string) => Promise<void>;
}

export function LoginForm({ onSubmit }: LoginFormProps) {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await onSubmit(identifier, password);
    } catch (e) {
      setError((e as Error).message);
      setBusy(false);
    }
  }

  return (
    <div className="flex w-full max-w-[380px] flex-col items-center gap-7">
      <Wordmark size="lg" />
      <Card as="form" raised className="flex w-full flex-col gap-4 p-7" onSubmit={submit}>
        <div>
          <h1 className="text-2xl">Sign in</h1>
          <p className="mt-1 text-[13px] text-fg-muted">Server and application health for Citilight clients.</p>
        </div>

        <FormField label="Username or email">
          <Input
            size="lg"
            autoComplete="username"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            required
            autoFocus
          />
        </FormField>
        <FormField label="Password">
          <Input
            size="lg"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </FormField>

        {error && (
          <p role="alert" className="rounded-lg bg-chip-critical-bg px-3 py-2 text-[13px] font-medium text-chip-critical-fg">
            {error}
          </p>
        )}

        <Button type="submit" variant="primary" size="lg" disabled={busy} className="mt-1">
          {busy ? 'Signing in…' : 'Sign in'}
        </Button>
      </Card>
    </div>
  );
}
